<template>
  <modal
    :show.sync="show"
    footerClasses="justify-content-center rounded"
    headerClasses="bg-success text-light text-uppercase"
    bodyClasses="px-4"
    @close="closed"
  >
    <h5 slot="header" class="modal-title">
      {{ disableEditShift ? "VISUALIZADOR DE TURNO" : "EDITAR TURNO" }}
    </h5>
    <div>
      <div class="d-flex">
        <fg-input
          type="text"
          label="Nombre Turno"
          class=""
          v-model="shiftData.descripcionTurno"
          placeholder=""
          :readonly="disableEditShift"
        >
        </fg-input>
      </div>
      <div class="d-flex flex-column py-2">
        <div class="row mr-2 border-bottom">
          <div class="col-md-4 d-flex flex-column">
            <label class="mb-0">Lunes</label>
            <p-switch
              class="my-2"
              :disabled="disableEditShift"
              v-model="shiftData.lunesAutorizado"
              type="success"
              on-text="SI"
              off-text="NO"
            ></p-switch>
          </div>
          <div v-if="shiftData.lunesAutorizado" class="col-md-4">
            <label class="mb-0">Inicio</label>
            <div class="form-group">
              <el-time-select
                size="small"
                :disabled="disableEditShift"
                v-model="shiftData.lunesHoraInicio"
                :picker-options="{
                  start: '00:00',
                  step: '00:01',
                  end: '23:59',
                }"
                class="my-auto"
                placeholder="     Hora de inicio"
              >
              </el-time-select>
            </div>
          </div>
          <div v-if="shiftData.lunesAutorizado" class="col-md-4">
            <label class="mb-0">Fin</label>
            <div class="form-group">
              <el-time-select
                size="small"
                class="my-auto"
                :disabled="disableEditShift"
                v-model="shiftData.lunesHoraTermino"
                :picker-options="{
                  start: '00:00',
                  step: '00:01',
                  end: '23:59',
                }"
                placeholder="     Hora de termino"
              >
              </el-time-select>
            </div>
          </div>
        </div>
        <div class="row mr-2 border-bottom">
          <div class="col-md-4 d-flex flex-column">
            <label class="mb-0">Martes</label>
            <p-switch
              class="my-1"
              :disabled="disableEditShift"
              v-model="shiftData.martesAutorizado"
              type="success"
              on-text="SI"
              off-text="NO"
            ></p-switch>
          </div>
          <div v-if="shiftData.martesAutorizado" class="col-md-4">
            <label class="mb-0">Inicio</label>
            <div class="form-group">
              <el-time-select
                size="small"
                :disabled="disableEditShift"
                v-model="shiftData.martesHoraInicio"
                :picker-options="{
                  start: '00:00',
                  step: '00:01',
                  end: '23:59',
                }"
                placeholder="     Hora de inicio"
              >
              </el-time-select>
            </div>
          </div>
          <div v-if="shiftData.martesAutorizado" class="col-md-4">
            <label class="mb-0">Fin</label>
            <div class="form-group">
              <el-time-select
                size="small"
                :disabled="disableEditShift"
                v-model="shiftData.martesHoraTermino"
                :picker-options="{
                  start: '00:00',
                  step: '00:01',
                  end: '23:59',
                }"
                placeholder="     Hora de termino"
              >
              </el-time-select>
            </div>
          </div>
        </div>
        <div class="row mr-2 border-bottom">
          <div class="col-md-4 d-flex flex-column">
            <label class="mb-0">Miercoles</label>
            <p-switch
              class="my-1"
              :disabled="disableEditShift"
              v-model="shiftData.miercolesAutorizado"
              type="success"
              on-text="SI"
              off-text="NO"
            ></p-switch>
          </div>
          <div v-if="shiftData.miercolesAutorizado" class="col-md-4">
            <label class="mb-0">Inicio</label>
            <div class="form-group">
              <el-time-select
                size="small"
                :disabled="disableEditShift"
                v-model="shiftData.miercolesHoraInicio"
                :picker-options="{
                  start: '00:00',
                  step: '00:01',
                  end: '23:59',
                }"
                placeholder="     Hora de inicio"
              >
              </el-time-select>
            </div>
          </div>
          <div v-if="shiftData.miercolesAutorizado" class="col-md-4">
            <label class="mb-0">Fin</label>
            <div class="form-group">
              <el-time-select
                size="small"
                :disabled="disableEditShift"
                v-model="shiftData.miercolesHoraTermino"
                :picker-options="{
                  start: '00:00',
                  step: '00:01',
                  end: '23:59',
                }"
                placeholder="     Hora de termino"
              >
              </el-time-select>
            </div>
          </div>
        </div>
        <div class="row mr-2 border-bottom">
          <div class="col-md-4 d-flex flex-column">
            <label class="mb-0">Jueves</label>
            <p-switch
              class="my-1"
              :disabled="disableEditShift"
              v-model="shiftData.juevesAutorizado"
              type="success"
              on-text="SI"
              off-text="NO"
            ></p-switch>
          </div>
          <div v-if="shiftData.juevesAutorizado" class="col-md-4">
            <label class="mb-0">Inicio</label>
            <div class="form-group">
              <el-time-select
                size="small"
                :disabled="disableEditShift"
                v-model="shiftData.juevesHoraInicio"
                :picker-options="{
                  start: '00:00',
                  step: '00:01',
                  end: '23:59',
                }"
                placeholder="     Hora de inicio"
              >
              </el-time-select>
            </div>
          </div>
          <div v-if="shiftData.juevesAutorizado" class="col-md-4">
            <label class="mb-0">Fin</label>
            <div class="form-group">
              <el-time-select
                size="small"
                :disabled="disableEditShift"
                v-model="shiftData.juevesHoraTermino"
                :picker-options="{
                  start: '00:00',
                  step: '00:01',
                  end: '23:59',
                }"
                placeholder="     Hora de termino"
              >
              </el-time-select>
            </div>
          </div>
        </div>
        <div class="row mr-2 border-bottom">
          <div class="col-md-4 d-flex flex-column">
            <label class="mb-0">Viernes</label>
            <p-switch
              class="my-1"
              :disabled="disableEditShift"
              v-model="shiftData.viernesAutorizado"
              type="success"
              on-text="SI"
              off-text="NO"
            ></p-switch>
          </div>
          <div v-if="shiftData.viernesAutorizado" class="col-md-4">
            <label class="mb-0">Inicio</label>
            <div class="form-group">
              <el-time-select
                size="small"
                :disabled="disableEditShift"
                v-model="shiftData.viernesHoraInicio"
                :picker-options="{
                  start: '00:00',
                  step: '00:01',
                  end: '23:59',
                }"
                placeholder="     Hora de inicio"
              >
              </el-time-select>
            </div>
          </div>
          <div v-if="shiftData.viernesAutorizado" class="col-md-4">
            <label class="mb-0">Fin</label>
            <div class="form-group">
              <el-time-select
                size="small"
                :disabled="disableEditShift"
                v-model="shiftData.viernesHoraTermino"
                :picker-options="{
                  start: '00:00',
                  step: '00:01',
                  end: '23:59',
                }"
                placeholder="     Hora de termino"
              >
              </el-time-select>
            </div>
          </div>
        </div>
        <div class="row mr-2 border-bottom">
          <div class="col-md-4 d-flex flex-column">
            <label class="mb-0">Sabado</label>
            <p-switch
              class="my-1"
              :disabled="disableEditShift"
              v-model="shiftData.sabadoAutorizado"
              type="success"
              on-text="SI"
              off-text="NO"
            ></p-switch>
          </div>
          <div v-if="shiftData.sabadoAutorizado" class="col-md-4">
            <label class="mb-0">Inicio</label>
            <div class="form-group">
              <el-time-select
                size="small"
                :disabled="disableEditShift"
                v-model="shiftData.sabadoHoraInicio"
                :picker-options="{
                  start: '00:00',
                  step: '00:01',
                  end: '23:59',
                }"
                placeholder="     Hora de inicio"
              >
              </el-time-select>
            </div>
          </div>
          <div v-if="shiftData.sabadoAutorizado" class="col-md-4">
            <label class="mb-0">Fin</label>
            <div class="form-group">
              <el-time-select
                size="small"
                :disabled="disableEditShift"
                v-model="shiftData.sabadoHoraTermino"
                :picker-options="{
                  start: '00:00',
                  step: '00:01',
                  end: '23:59',
                }"
                placeholder="     Hora de termino"
              >
              </el-time-select>
            </div>
          </div>
        </div>
        <div class="row mr-2">
          <div class="col-md-4 d-flex flex-column">
            <label class="mb-0">Domingo</label>
            <p-switch
              class="my-1"
              :disabled="disableEditShift"
              v-model="shiftData.domingoAutorizado"
              type="success"
              on-text="SI"
              off-text="NO"
            ></p-switch>
          </div>
          <div v-if="shiftData.domingoAutorizado" class="col-md-4">
            <label class="mb-0">Inicio</label>
            <div class="form-group">
              <el-time-select
                size="small"
                :disabled="disableEditShift"
                v-model="shiftData.domingoHoraInicio"
                :picker-options="{
                  start: '00:00',
                  step: '00:01',
                  end: '23:59',
                }"
                placeholder="     Hora de inicio"
              >
              </el-time-select>
            </div>
          </div>
          <div v-if="shiftData.domingoAutorizado" class="col-md-4">
            <label class="mb-0">Fin</label>
            <div class="form-group">
              <el-time-select
                size="small"
                :disabled="disableEditShift"
                v-model="shiftData.domingoHoraTermino"
                :picker-options="{
                  start: '00:00',
                  step: '00:01',
                  end: '23:59',
                }"
                placeholder="     Hora de termino"
              >
              </el-time-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      slot="footer"
      class="d-flex flex-row justify-content-center w-100 py-1 bg-success rounded-bottom"
    >
      <template v-if="disableEditShift">
        <div class="col-3">
          <p-button class="ml-3 shadow-sm" type="danger" icon round
            ><i
              class="fa fa-chevron-left fa-lg font-weight-bold"
              @click="stepBack"
            ></i
          ></p-button>
        </div>
        <div class="col-6 d-flex justify-content-center">
          <button
            class="btn rounded-pill bg-light text-secondary btn-sm shadow-sm"
            @click="enableEdit"
          >
            editar
          </button>
          <!-- <button class="btn rounded-pill btn-success btn-sm">OK</button> -->
        </div>
        <div class="col-3"></div>
      </template>
      <template v-else>
        <div class="col-3 d-flex">
          <p-button class="ml-3" type="danger" icon round @click="stepBack"
            ><i class="fa fa-chevron-left fa-lg font-weight-bold"></i
          ></p-button>
        </div>
        <div class="col-6 d-flex justify-content-center">
          <p-button
            type="success"
            class="btn rounded-pill bg-light text-secondary btn-sm shadow-sm mr-1"
            @click="saveChanges"
            >GUARDAR</p-button
          >
          <p-button
            type="danger"
            @click="disableEdit"
            class="btn-sm btn-success btn rounded-pill ml-1 shadow-sm"
            >CANCELAR</p-button
          >
        </div>
        <div class="col-3 d-flex"></div>
      </template>
    </div>
  </modal>
</template>

<script>
import { Badge, Modal } from "src/components/UIComponents";
import PSwitch from "src/components/UIComponents/Switch.vue";
import {
  DatePicker,
  TimeSelect,
  Slider,
  Tag,
  Input,
  Button,
  Select,
  Option,
  Table,
  TableColumn,
} from "element-ui";
export default {
  name: "ShiftUpdateModal",
  components: {
    [Select.name]: Select,
    [Input.name]: Input,
    [Button.name]: Button,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    Modal,
    Badge,
    PSwitch,
    // [Tooltip.name]: Tooltip,
  },
  props: {
    shiftData: {
      type: Object,
      default: () => ({
        idTurno: 0,
        lunesAutorizado: true,
        martesAutorizado: true,
        miercolesAutorizado: true,
        juevesAutorizado: true,
        viernesAutorizado: true,
        sabadoAutorizado: true,
        domingoAutorizado: true,
        descripcionTurno: "TURNO DEFAULT",
        lunesHoraInicio: "09:30:00",
        lunesHoraTermino: "19:00:00",
        martesHoraInicio: "09:30:00",
        martesHoraTermino: "19:00:00",
        miercolesHoraInicio: "09:30:00",
        miercolesHoraTermino: "19:00:00",
        juevesHoraInicio: "09:30:00",
        juevesHoraTermino: "19:00:00",
        viernesHoraInicio: "09:30:00",
        viernesHoraTermino: "19:00:00",
        sabadoHoraInicio: "09:30:00",
        sabadoHoraTermino: "19:00:00",
        domingoHoraInicio: "09:30:00",
        domingoHoraTermino: "19:00:00",
      }),
    },
    // disableEditShift: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  data() {
    return {
      show: false,
      disableEditShift: true,
      shiftDataOG: {},
    };
  },
  methods: {
    test(data) {
      console.log(data);
    },
    saveChanges() {
      this.$emit("saveChanges", this.shiftData);
      this.disableEditShift = true
      this.shiftDataOG = {}
      this.$nextTick(() => {
        this.show = false;
      });
    },
    stepBack() {
      this.show = false;
      this.$emit("stepBack", this.shiftDataOG);
      this.disableEditShift = true;
      this.$nextTick(() => {
        this.shiftDataOG = {};
      });
    },
    closed() {
      this.disableEditShift = true;
      this.shiftDataOG = {};
      this.$emit("closed");
    },
    enableEdit() {
      this.shiftDataOG = _.cloneDeep(this.shiftData);
      this.disableEditShift = false;
    },
    disableEdit() {
      this.disableEditShift = true;
      this.$emit("disableEdit", this.shiftDataOG);
    },
    showModal() {
      this.show = true;
    },
  },
  watch: {
    showProp: function (newValue) {
      // console.log("changin");
      this.show = newValue;
    },
  },
};
</script>

<style></style>
